import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NavigationService} from '../../../services';
import {Location} from '@angular/common';
import {Router} from '@angular/router';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent implements OnInit {

  @Input() titulo: string = `Nuevo Header`;
  @Input() backButton: boolean = false;
  @Input() backButtonDefaultURL: string = '';
  @Input() forceBackButtonURL: string = '';

  @Input() catchBackButton: boolean = false;
  @Output() backButttonPressed = new EventEmitter();

  constructor(
    private navigationService: NavigationService,
    private location: Location,
    private router: Router
  ) { }

  ngOnInit() { }

  toggleNav() {
    this.navigationService.toggleNav(true);
  }

  public navigateBack() {
    if (this.catchBackButton) {
      this.backButttonPressed.emit();
    } else {
      this.navigateBackAfterCatch();
    }
  }

  public catchEnded() {
    this.navigateBackAfterCatch();
  }

  private navigateBackAfterCatch() {
    if (this.forceBackButtonURL !== '') {
      this.router.navigateByUrl('/' + this.forceBackButtonURL);
    } else if (this.navigationService.isBackBtnReady()) {
      this.location.back();
    } else {
      this.router.navigateByUrl('/' + this.backButtonDefaultURL);
    }
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/page-header/page-header.component.ts